import AppLogo from "assets/logo.png";
import { MenuItem } from "model/home";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { history } from "router";
import { useHomePage } from "store/home";
import "./index.scss";

const AppHeader = () => {
  const { pathname } = useLocation();
  const {
    mainMenuList,
    subMenuOpened,
    setMainMenuActive,
    setSubMenuOpened,
    clearMainMenuActive,
  } = useHomePage();
  const currentMainMenu = mainMenuList.find((item) => item.active);
  const subMenuList = currentMainMenu?.children || [];

  const handleMainMenuClick = (menu: MenuItem) => {
    setMainMenuActive(menu.id);
    if (menu.id === 0) {
      setSubMenuOpened(!subMenuOpened);
    } else {
      setSubMenuOpened(false);
    }

    history.push(menu.url!);
  };

  const handleBgCoverClick = () => {
    setSubMenuOpened(false);
    clearMainMenuActive();
  };

  useEffect(() => {
    const index = mainMenuList.findIndex((item) => item.url === pathname);

    if (index > 0) {
      setMainMenuActive(index);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`app-header ${subMenuOpened ? "active" : ""}`}>
      <div className="app-navigation">
        <div className="app-navigation-content">
          <a className="app-logo" href="/">
            <img src={AppLogo} alt="logo" />
          </a>

          <nav className="app-menubar">
            {mainMenuList.map((item) => (
              <span
                className={`link-btn ${item.active ? "active" : ""}`}
                onClick={handleMainMenuClick.bind(null, item)}
                key={item.id}
              >
                {item.title}
              </span>
            ))}
          </nav>
        </div>
      </div>

      <div className="app-sub-navigation">
        <div className="app-sub-navigation-content">
          {subMenuList.map((item) => (
            <div className="sub-navigation-item" key={item.id}>
              <h6 className="title">{item.title}</h6>
              <div className="content">
                {item.children &&
                  item.children.map((item) => (
                    <span className="text-wrap" key={item.id}>
                      <span className="text">{item.title}</span>
                    </span>
                  ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-cover" onClick={handleBgCoverClick}></div>
    </div>
  );
};

export default AppHeader;
